import React, { ReactElement } from "react";
import { Text } from "@xometry/xometry_loft";
import Modal from "../Common/Modal";
import { ModalStyles } from "./styles";

interface CancelQuoteModalProps {
  modalOpen: boolean;
  setModal: (boolean) => void;
  onSubmit?: () => void;
}

const CancelQuoteModal = ({
  modalOpen,
  setModal,
  onSubmit,
}: CancelQuoteModalProps): ReactElement => {
  return (
    <Modal
      isOpen={modalOpen}
      selector="#modal-mount"
      title={<Text kind="panel-title">Cancel Quote</Text>}
      description={
        <Text>
          Canceling this quote will prevent the customer from ordering, and they
          will no longer have access to this quote. Canceled quotes can be
          resubmitted at any time.
        </Text>
      }
      submitActionText="Cancel Quote"
      submitButtonType="primary-thomas"
      discardActionText="Dismiss"
      handleSubmit={onSubmit}
      handleCloseButton={() => setModal(false)}
      handleCancel={() => setModal(false)}
      cssStyle={ModalStyles}
      buttonScale="large"
    />
  );
};

CancelQuoteModal.defaultProps = {
  onSubmit: undefined,
};

export default CancelQuoteModal;
